module.exports = () => {
  return {
    name: {
      label: '试玩页名称',
      type: 'input',
      value: '',
    },
  };
};
